/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ProfileCardSchema } from './profileCardSchema';
import type { SearchResultsPageSchemaExternalPhase } from './searchResultsPageSchemaExternalPhase';

/**
 * GET /searches/{id}/results: one page from the search's latest READY run.
 *
 * ``run_id`` is the run the items came from (None when nothing is ready yet);
 * ``external_phase`` is the *latest* run's phase so the client can keep
 * showing stale-but-ready results while a newer run is in flight.
 */
export interface SearchResultsPageSchema {
  run_id?: string | null;
  external_phase: SearchResultsPageSchemaExternalPhase;
  profiles?: ProfileCardSchema[];
  total_count?: number;
  page: number;
  per_page: number;
}
